import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SearchComponent } from './pages/search/search.component';
import { ResultsComponent } from './pages/results/results.component';

const routes: Routes = [
    { path: '', component: SearchComponent },
    { path: 'consulta', component: ResultsComponent },
    { path: '**', component: SearchComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
